module.exports = __webpack_public_path__ + "static/media/ic_account_control.2b1abc55.svg";